/**
 * Labels for a grouped item list whose sections page and search on their own.
 * Accessible names and one empty line — shared by every host of that list.
 */
export enum ListSectionLabel {
  /** Composed with the section name: "Search activities". */
  SearchPrefix = 'Search',
  /** A section whose search matches none of its rows. */
  NoMatch = 'Nothing here matches that.',
  /** Composed with the section name: "Activities pages". */
  Pages = 'pages',
  /** Composed with the page number: "Page 2". */
  Page = 'Page',
  Previous = 'Previous page',
  Next = 'Next page',
}
